import React from "react";
import Modal from "../../Modal";
import { observer, inject } from "mobx-react";

@inject("UIStore")
@observer
export default class TrudatAnnouncement extends React.Component {
  render() {
    var settings = this.props.settings.settings;
    return (
      <div className="container hp__block padding">
        {this.props.UIStore.popUpsVisiblity["modal"] && <Modal />}
        <div className="col-md-12">
          <div className="hp__block__announcement text-center">
            <h4>
              {" "}
              {!settings ? "Zapowiedzi Trudatów" : settings.header_grey}{" "}
            </h4>
            <h2>
              {" "}
              {!settings
                ? "Dodaj nagłówek w ustawieniach sekcji"
                : settings.header_main}{" "}
            </h2>
            <button
              onClick={() => this.props.UIStore.togglePopUpVisibility("modal")}
              className="hp__block__announcement-button modal-show"
            >
              {" "}
              Zgłoś temat trudata{" "}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
